module.exports = __webpack_public_path__ + "img/mlops-heng.23f61a69.png";